import React, { forwardRef } from 'react';
import LxInput from '@lingxi-common-component/sirius-ui/Input';
import SearchIcon from '../../Icons/svgs/SearchSvg';
import { getIn18Text } from 'api';
import styles from './index.module.scss';
const SearchInput = forwardRef((props, ref) => {
    const { value, autoFocus = true, onChange, onKeyDown, onPressEnter, className = '' } = props;
    return (React.createElement("div", { className: styles.contactSearchWrap },
        React.createElement(LxInput, { "data-test-id": "contact_selectList_search_input", className: `${styles.contactSearch} ${className}`, ref: ref, value: value, autoFocus: autoFocus, onKeyDown: onKeyDown, onPressEnter: onPressEnter, onChange: onChange, placeholder: getIn18Text('QINGSHURUSOUSUO'), prefix: React.createElement(SearchIcon, { className: "dark-invert" }), allowClear: true })));
});
export default SearchInput;
